import {
  TextBlock,
  CallToActionCampaign,
  CallToAction,
  FeedbackToolBlock,
} from '../implementations';

const mappers = {
  text: TextBlock,
  call_to_action: CallToAction,
  call_to_action_campaign: CallToActionCampaign,
  feedback: FeedbackToolBlock,
};

export default mappers;

